import { AutogenLayoutLeaveStatementsReport } from "./autogen/AutogenLayoutLeaveStatementsReport";

/**
 * Leave Statements Report - Extension class with custom business logic
 */
export class LeaveStatementsReport extends AutogenLayoutLeaveStatementsReport {

    override onLoad(): void {
        super.onLoad();
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
    }
}
